// API
export const PRO_CONFIG = {
	serviceName: '首页资讯',
	serviceId: 'ZFT_ZFTHOME',
	Vconsole: false,
	Homeapi: 'https://api.fcsc.com/zfthomeService', // 生产环境
	Imgapi: 'https://con.fcsc.com/fileapi/fileapi/displayImage/', // 生产环境
	APIOpenAccountURL: 'https://kh.fcsc.com/fcsc/acct4/index.html?ls=CFT&ocr=1&color=3b3a3e', // 跳转开户页面生产URL
	WXOpenAccountURL: 'https://kh.fcsc.com/fcsc/acct4/index.html?ls=YCYFH', // 在微信端的开户跳转链接生产
	APIDAzhangguURL: 'https://zfthome.95358.com/zfthome/#/dzgjd/index', // 大涨股解读页面生产URL
	alreadyReadSign: 'https://api.fcsc.com/baseservice/protected/readed/save?', // 添加已读标识生产环境
	queryReadSign: 'https://api.fcsc.com/baseservice/protected/readed/query?', // 查询已读标识生产环境
	collectInfo: 'https://api.fcsc.com/zfthomeService/collectPlateMsg/save', // 收藏资讯生产环境
	cancelCollectInfo: 'https://api.fcsc.com/zfthomeService/collectPlateMsg/cancelCollect', // 取消资讯收藏生产环境
	queryCollectInfo: 'https://api.fcsc.com/zfthomeService/collectPlateMsg/queryPlateMsgByDeviceId', // 查询资讯收藏列表生产环境
	Codeapi: 'https://h5hqservice.95358.com:8443', // 获取股票涨跌幅生产环境
	Buriedapi: 'https://api.fcsc.com/baseservice/protected/evidence/save', // 埋点API
    dzjy: 'https://news.fcsc.com/zftNews/#/dzjy/home', // 大宗交易生产环境
    rzrq: 'https://news.fcsc.com/zftNews/#/rzrq/home', // 融资融券
    lrzx: 'https://exterior.21fid.com/dycy#/margintrading', // 两融资讯
    kcIPO: 'https://news.fcsc.com/zftNews/#/sTib/home', // 科创IPO
   	lhb: 'https://news.fcsc.com/toplist/#/', // 龙虎榜
	yhq: 'https://news.fcsc.com', // 优惠券
    mnjy: 'https://digitinfo.95358.com/api/v1/addimitate-h5/#/addimitate?hideNavLeft=true', // 模拟交易
    wqapi: 'https://zfthome.95358.com/zfthome/#', // 往期活动页面
   	yjbx: 'https://news.fcsc.com/zftNews/#/yjbxPage/index', // 业绩表现生产环境
	sskxApi: 'https://news.fcsc.com/infoservice', // 快讯
	tdxzxApi: 'https://ggzx.95358.com/tdxpczx', // 通达信资讯
	newsUrl: 'https://news.fcsc.com/zftNews/#/',
	digitinfo: 'https://digitinfo.95358.com',
	dstxapi: 'https://ggzx.95358.com:7615',
	appName: 'zft',
	appVersion: '1.0',
	StockAPI_appkey: 'AweQp0CpVfjaccTMQ3OpNcgEXpvGCFTwwhRTOi2KebY=',
   	aplus: 'track.fcsc.com', // 阿里云埋点配置
	appKey: '4by7uvdzu9epcpffbadb881t', // 阿里云埋点配置
	zszs: 'https://news.fcsc.com/zftNews/#/indexDisplay/index', // 指数展示
	fhsz: 'https://news.fcsc.com/zftNews/#/fhsz/home', // 分红送转
	tjcb: 'https://b2b-api.10jqka.com.cn/b2bgw/resource/h5/private/DYCY/latest/GraphicReport/GraphicReport/index.html#/search?ckey=65647BA00005', // 图解财报
	fkjj: 'https://b2b-api.10jqka.com.cn/b2bgw/resource/h5/private/DYCY/latest/tuyerePlatev2/tuyerePlatev2/index.html#/home?ckey=65647C020006', // 风口掘金
	gljj: 'https://news.fcsc.com/zftNews/#/gljj/index', // 关联基金
	szly: 'https://news.fcsc.com/zftNews/#/shroadshow/home', // 上证路演
	ggzx: 'https://ggzx.95358.com', // 个股资讯
	xgxz: 'https://api.fcsc.com/news-service', // 新股新债
	sdipo: '649d59a8c8224e7337cc0cdd', // 数读Ipo
	jjdt: 'NEWSZDY05', // 基金动态
	zxapi: 'https://api.fcsc.com/selfStockService', // 自选股
	baseapi: 'https://api.fcsc.com/baseservice', // base服务
	lcsc: 'https://fin.fcsc.com/finmarket-boot', // 理财
	news: 'https://news.fcsc.com',
	clgj: 'https://tradestrategy.95358.com:8000/h5',
	digit: 'http://digit.95358.com',
	dbzs: 'https://tradestrategy.95358.com:8000/h5/mall/index.html#/detail?isExternal=1&productId=2220',
	wpqc: '2205'
}


// WEBPACK FOOTER //
// ./src/api/config_master.js